module.exports = __webpack_public_path__ + "img/Porto Apartment - 43 of 85.8f16d43d.jpeg";